import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-content fade-in-up">
        <h1>Empowering Dreams Through Education</h1>
        <p>Supporting students from school to college, breaking down financial barriers to learning.</p>
        <a href="#about" className="btn btn-primary">Learn More</a>
      </div>
    </section>
  );
};

export default Hero;